import type { RouteObject } from 'react-router-dom';
import { PERMISSIONS } from '@optiflow/types';
import { RequirePermission } from '@/routes/RequirePermission';
import { PayableInvoiceDetailPage } from './pages/PayableInvoiceDetailPage';
import { PayableInvoicesPage } from './pages/PayableInvoicesPage';
import { RecordSupplierPaymentPage } from './pages/RecordSupplierPaymentPage';
import { SupplierPaymentDetailPage } from './pages/SupplierPaymentDetailPage';
import { SupplierPaymentsPage } from './pages/SupplierPaymentsPage';

/** Wraps a route in its guard, so the permission is refused before anything is requested. */
function guarded(permission: string, route: RouteObject): RouteObject {
  return { element: <RequirePermission permission={permission} />, children: [route] };
}

/**
 * The payables routes beneath the dashboard, which the navigation itself provides.
 *
 * Reading is `payables.view` throughout; recording a payment is `payables.pay` and nothing else —
 * no purchasing capability appears anywhere here, because settling an invoice is not buying.
 *
 * `payments/new` is declared before the dynamic segment so it is never read as a payment id.
 */
export const payablesRoutes: RouteObject[] = [
  guarded(PERMISSIONS.PAYABLES_PAY, {
    path: '/finance/payables/payments/new',
    element: <RecordSupplierPaymentPage />,
  }),
  guarded(PERMISSIONS.PAYABLES_VIEW, {
    path: '/finance/payables/invoices',
    element: <PayableInvoicesPage />,
  }),
  guarded(PERMISSIONS.PAYABLES_VIEW, {
    path: '/finance/payables/invoices/:invoiceId',
    element: <PayableInvoiceDetailPage />,
  }),
  guarded(PERMISSIONS.PAYABLES_VIEW, {
    path: '/finance/payables/payments',
    element: <SupplierPaymentsPage />,
  }),
  guarded(PERMISSIONS.PAYABLES_VIEW, {
    path: '/finance/payables/payments/:paymentId',
    element: <SupplierPaymentDetailPage />,
  }),
];
